import { cleanNumber } from "helpers/cleanNumbers";
import { createSelector } from "reselect";

export const expenseSelector = createSelector(state => {
  const { expenses, companies: { stations } } = state
  const categories = expenses?.categories
  const expensesM = expenses?.expenses.map(exp => {
    const category = categories.find(cat => cat.id === exp.idExpenseCategory)
    let newAmount = 0
    let amountByStation = 0
    newAmount = Number(exp.amount)
    amountByStation = cleanNumber(exp.amountByStation)
    return {
      ...exp,
      station: stations[exp.idStation]?.label,
      category: category?.name,
      amountC: newAmount,
      amountByStationC: amountByStation,
      type: category?.type,
    }
  })
  return expensesM
}, expenses => expenses)